import {useEffect, useState} from "react";
import AlbumReviewService from "../../services/reviews/AlbumReviewService";
import {getRandomColor} from "../../utils/GetRandomColor";
import IconText from "../IconText";
import {faStar} from "@fortawesome/free-solid-svg-icons/faStar";

export default function AlbumReviewTable() {
    const [reviews, setReviews] = useState([]);
    const [isNarrowScreen, setIsNarrowScreen] = useState(window.innerWidth <= 768);

    useEffect(() => {
        const handleResize = () => {
            setIsNarrowScreen(window.innerWidth <= 992);
        };

        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    useEffect(() => {
        const fetchReviews = async () => {
            try {
                const data = await AlbumReviewService.getAllReviews();
                const sortedData = data.sort((b, a) => b.overallRating - a.overallRating);
                setReviews(sortedData);
            } catch (error) {
                console.error("Failed to fetch reviews:", error);
            }
        };

        fetchReviews();
    }, []);

    // Scale factor for narrow screens - adjust this value to experiment
    const scaleFactor = isNarrowScreen ? 0.6 : 1;
    
    const baseFontSize = 48;
    const basePadding = 10;

    const gridContainerStyle = {
        display: 'grid',
        gridTemplateColumns: isNarrowScreen ? 'repeat(3, 1fr)' : 'repeat(auto-fill, minmax(250px, 1fr))',
        gap: '0',
    };

    const imageStyle = {
        width: '100%',
        aspectRatio: '1 / 1',
        objectFit: 'cover'
    };
    
    const containerStyle = {
        position: 'relative',
        width: '100%',
    };
    const overlayStyle = {
        position: 'absolute',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        backgroundColor: 'rgba(0, 0, 0, 0.8)',
        color: 'white',
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'end',
        alignItems: 'start',
        opacity: 0,
        transition: 'opacity 0.3s',
        padding: `${basePadding * scaleFactor}px`,
        boxSizing: 'border-box',
        textAlign: 'left'
    };
    const ratingStyle = {
        fontSize: `${baseFontSize * scaleFactor}px`,
        fontWeight: 'bold',
    };
    const albumNameStyle = {
        margin: '0',
        fontSize: `${20 * scaleFactor}px`,
    };
    const artistNameStyle = {
        fontSize: `${16 * scaleFactor}px`,
    }

    return (
        <div style={gridContainerStyle}>
            {reviews.map((review) => (
                <div key={review.id} style={containerStyle}>
                    <img
                        src={review.imgLink}
                        alt={review.albumName}
                        style={{...imageStyle,
                            border: getRandomColor() + ' solid 5px'}}
                    />
                    <div
                        style={overlayStyle}
                        onMouseEnter={(e) => e.currentTarget.style.opacity = 1}
                        onMouseLeave={(e) => e.currentTarget.style.opacity = 0}
                    >
                        <p style={ratingStyle}>
                            <IconText icon={faStar} text={review.overallRating} bgColor={true}/>
                        </p>
                        <h3 style={albumNameStyle}>{review.albumName}</h3>
                        <p style={artistNameStyle}>{review.artistName}</p>
                    </div>
                </div>
            ))}
        </div>
    )
}
